import Vue from 'vue'
import {
  getPost,
  getPosts,
  createPost,
  updatePost,
  deletePost,
  publishPost,
  unpublishPost,
  deleteImage
} from '../api'

import { getField, updateField } from 'vuex-map-fields';

const getDefaultState = () => {
  return {
    posts: [],
    editing: false,
    saved: false,
    currentPost : {
      id: null,
      artist : null,
      title: null,
      description: null,
      year: null,
      width: null,
      height: null,
      sku: null,
      medium: null,
      location: null
    }
  }
}

// initial state
const state = getDefaultState()

const mutations = {
  updateField,
  // viewing
  SET_ALL_POSTS(state, posts) {
    state.posts = posts
  },
  SET_CURRENT_POST(state, post) {
    state.currentPost = post
  },
  UPDATE_CURRENT_POST(state, post) {
    state.currentPost = {
      ...state.currentPost,
      ...post
    }
  },
  // editing
  REMOVE_POST(state, post) {
    const index = state.posts
      .map(p => p.id)
      .indexOf(post.id)
    state.posts.splice(index, 1)
  },
  SET_EDITING_MODE(state, editing) {
    state.editing = editing
  },
  UNSET_EDITING_MODE(state, editing) {
    state.editing = false
  },
  POST_IS_CHANGING(state) {
    state.saved = false
  },
  POST_IS_SAVED(state) {
    state.saved = true
  }
}

const actions = {
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  getPost({ commit }, { postId }) {
    getPost(postId)
      .then(post => commit('SET_CURRENT_POST', post.data))
  },
  getPosts({ commit }) {
    getPosts()
      .then(posts => commit('SET_ALL_POSTS', posts.data))
  },
  savePost({ commit, state }, { postId }) {
    const postData = {...state.currentPost}
    console.log(postId, postData)

    if (postId) {
      updatePost(postId, postData)
        .then(updatedPost => {
          commit('UPDATE_CURRENT_POST', updatedPost)
          commit('POST_IS_SAVED')
        })
    } else {
      createPost(postData)
        .then(newPost => {
          commit('UPDATE_CURRENT_POST', newPost)
          commit('POST_IS_SAVED')
        })
    }
  },
  deletePost({ commit }, { postId }) {
    deletePost(postId)
      .then(deletedPostId => commit('REMOVE_POST', deletedPostId))
  },
  publishPost({ commit }, { postId }) {
    publishPost(postId)
      .then(post => commit('UPDATE_CURRENT_POST', post))
  },
  unpublishPost({ commit }, { postId }) {
    unpublishPost(postId)
      .then(post => commit('UPDATE_CURRENT_POST', post))
  },
  setEditPost({ commit },  { postId }) {
    getPost(postId)
      .then(post => {
        commit('SET_CURRENT_POST', post.data)
        commit('SET_EDITING_MODE', true)
      })
  },
  deleteImage({ commit, state }, fileName) {
    deleteImage(fileName)
      .then( () => {
        if(state.currentPost.id) {
          updatePost(state.currentPost.id, { image : null }) // pass false to delete
            .then(updatedPost => {
              commit('UPDATE_CURRENT_POST', updatedPost.data)
              commit('POST_IS_SAVED')
            })
        }
      })
  }
}

/* eslint-disable no-new */
const getters = {
  getField,
  posts(state) {
    return state.posts
  },
  currentPost(state) {
    return state.currentPost || {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
